<script>
import { Pie, mixins } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  components: {
    ChartDataLabels,
  },
  mixins: [reactiveProp],
  props: ["options"],
  data() {
    return {
      htmlLegend: null,
      chartOptions: Object.assign(this.options, {
        legend: {
          ...this.options.legend,
          onClick: ((e, legendItem) => {
            var index = legendItem.index;
            var ci = this.$data._chart;
            var meta = ci.getDatasetMeta(0);

            // Toggle visibility
            meta.data[index].hidden = !meta.data[index].hidden;

            this.$emit("click-label", {
              e,
              legendItem,
              ci,
            });

            ci.update();
          }),
        },
      }),
    };
  },
  watch: {
    "$data._chart.data": {
      deep: true,
      handler(value) {
        this.htmlLegend = this.$data._chart.generateLegend();
        this.$emit("sendLegend", this.htmlLegend, this.$data._chart);
      },
    },
  },
  mounted() {
    // Добавляем плагин точно как в HorizontalBarChart
    this.addPlugin(ChartDataLabels);
    
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.chartOptions);
  },
};
</script> 